import { useCallback, useState } from 'react';

import { MODAL_SIZES, Modal, ModalHeader } from 'ui/modal';
import { isNull } from 'utils/tsHelpers';

import { SetupStep } from './SetupStep';
import { FormState } from './types';
import { ReviewChangesStep } from './ReviewChangesStep';
import { FeatureFlag } from '../../types';
import { FeatureContextProvider } from './FeatureContext';

type ImportModalProps = {
  featureFlag: FeatureFlag;
  onClose: (didImport: boolean) => void;
  env: string;
};

export const ImportModal = ({ env, featureFlag, onClose }: ImportModalProps) => {
  const [submission, setSubmission] = useState<FormState | null>(null);

  const handleClose = useCallback(() => onClose(false), [onClose]);
  const handleImport = useCallback(() => onClose(true), [onClose]);

  return (
    <FeatureContextProvider featureFlag={featureFlag}>
      <Modal id="import-ids-modal" onClose={() => null} isModalOpen size={MODAL_SIZES.MEDIUM}>
        <ModalHeader onClose={handleClose}>{featureFlag.feature}</ModalHeader>
        {isNull(submission) ? (
          <SetupStep onClose={handleClose} onSubmit={setSubmission} />
        ) : (
          <ReviewChangesStep
            onGoBack={() => setSubmission(null)}
            idType={submission.idType}
            importType={submission.importType}
            changeComment={submission.changeComment}
            env={env}
            onSuccessfulImport={handleImport}
          />
        )}
      </Modal>
    </FeatureContextProvider>
  );
};
